import { render } from "./Proposal.vue?vue&type=template&id=1e931332"
import script from "./Proposal.vue?vue&type=script&lang=js"
export * from "./Proposal.vue?vue&type=script&lang=js"
script.render = render

export default script